var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddprdicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.33301,
    y: 0.6875,
    width: 22,
    height: 22,
    rx: 11,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.333 5.1875C8.74228 5.1875 5.83301 8.09677 5.83301 11.6875C5.83301 15.2782 8.74228 18.1875 12.333 18.1875C15.9237 18.1875 18.833 15.2782 18.833 11.6875C18.833 8.09677 15.9237 5.1875 12.333 5.1875ZM16.1072 12.4214C16.1072 12.5944 15.9657 12.7359 15.7927 12.7359H13.3814V15.1472C13.3814 15.3202 13.2399 15.4617 13.0669 15.4617H11.5991C11.4262 15.4617 11.2846 15.3202 11.2846 15.1472V12.7359H8.87333C8.70035 12.7359 8.55881 12.5944 8.55881 12.4214V10.9536C8.55881 10.7806 8.70035 10.6391 8.87333 10.6391H11.2846V8.22782C11.2846 8.05484 11.4262 7.91331 11.5991 7.91331H13.0669C13.2399 7.91331 13.3814 8.05484 13.3814 8.22782V10.6391H15.7927C15.9657 10.6391 16.1072 10.7806 16.1072 10.9536V12.4214Z",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.33301,
    y: 0.6875,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddprdicon);
export default __webpack_public_path__ + "static/media/addprdicon.e976b34a8ee6056dc8cb8ab51eea4cb0.svg";
export { ForwardRef as ReactComponent };